"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _product = require("@/api/product");
var _index = _interopRequireDefault(require("@/components/NoData/index.vue"));
var _vuePropertyDecorator = require("vue-property-decorator");
var ProductRatesModal = /*#__PURE__*/function (_Vue) {
  function ProductRatesModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductRatesModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductRatesModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "imageStar", require("@/assets/images/star.png"));
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "query", {
      limit: 10,
      page: 1
    });
    (0, _defineProperty2.default)(_this, "productId", null);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "total", 0);
    return _this;
  }
  (0, _inherits2.default)(ProductRatesModal, _Vue);
  return (0, _createClass2.default)(ProductRatesModal, [{
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context.sent;
              if (valid) {}
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context2.sent;
              if (valid) {}
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleOpen",
    value: function handleOpen(productId) {
      this.visible = true;
      this.query = {
        limit: 10,
        page: 1
      };
      this.productId = productId;
      this.fetchRates();
    }
  }, {
    key: "fetchRates",
    value: function fetchRates() {
      var _this2 = this;
      this.listLoading = true;
      _product.productApi.findRates(this.productId, this.query).then(function (res) {
        _this2.data = res.data.productRates;
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.listLoading = false;
      });
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)({}, data);
      this.visible = true;
      this.status = "update";
    }
  }]);
}(_vuePropertyDecorator.Vue);
ProductRatesModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    NoData: _index.default
  }
})], ProductRatesModal);
var _default = exports.default = ProductRatesModal;